module.exports = __webpack_public_path__ + "static/img/elegantMannersBig1.569d865c.png";